import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useUserRole } from '../../../context/UserRoleProvider'
import { Button } from '../../../components/ui/button'
import { Users, Building2, Shield } from 'lucide-react'

export default function AdminDashboard() {
  const navigate = useNavigate()
  const { isSuperAdmin } = useUserRole()

  if (!isSuperAdmin) {
    return (
      <div className="bg-red-50 border border-red-200 rounded p-6">
        <p className="text-red-600">You do not have permission to access this page.</p>
      </div>
    )
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold font-display text-charcoal mb-2">Admin Dashboard</h1>
          <p className="text-charcoal-muted">Manage users, parishes, and system settings</p>
        </div>
        <div className="flex items-center space-x-2">
          <Shield className="w-6 h-6 text-charcoal" />
          <span className="text-charcoal font-semibold">Super Admin</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Users Management Card */}
        <div className="bg-white border border-surface-border rounded p-6 hover:border-gold/50 transition-colors">
          <div className="flex items-center space-x-4 mb-4">
            <div className="bg-gold/10 p-3 rounded">
              <Users className="w-6 h-6 text-charcoal" />
            </div>
            <div>
              <h2 className="text-xl font-semibold font-display text-charcoal">Users</h2>
              <p className="text-charcoal-muted text-sm">Manage user accounts</p>
            </div>
          </div>
          <p className="text-charcoal-muted text-sm mb-4">
            View all users, assign roles, and manage parish associations
          </p>
          <Button
            onClick={() => navigate('/app/admin/users')}
            className="w-full bg-gold text-black hover:bg-gold/90"
          >
            Manage Users
          </Button>
        </div>

        {/* Parishes Management Card */}
        <div className="bg-white border border-surface-border rounded p-6 hover:border-gold/50 transition-colors">
          <div className="flex items-center space-x-4 mb-4">
            <div className="bg-gold/10 p-3 rounded">
              <Building2 className="w-6 h-6 text-charcoal" />
            </div>
            <div>
              <h2 className="text-xl font-semibold font-display text-charcoal">Parishes</h2>
              <p className="text-charcoal-muted text-sm">Manage all parishes</p>
            </div>
          </div>
          <p className="text-charcoal-muted text-sm mb-4">
            View, edit, and manage all parishes in the system
          </p>
          <Button
            onClick={() => navigate('/app/admin/parishes')}
            className="w-full bg-gold text-black hover:bg-gold/90"
          >
            Manage Parishes
          </Button>
        </div>
      </div>
    </div>
  )
}
